import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getReportHelpPartner = async (queries = '') => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `help-host-report/list?${queries}` });

  return data?.data;
};

export default getReportHelpPartner;
